import { useQuery } from "@tanstack/react-query";
import postsAPi from "../../api/posts/api";

export function getQueryKey() {
  return ["posts"];
}
export function useGetPosts() {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: postsAPi.getPosts,
  });
}
